<button type="button" class="button">
  {{ text }}
  <span class="icon icon-24 icon-arrow-right"></span>
</button>
